'use client';

import React from 'react';
import arrowImage from '../../assets/images/arrow-right.svg';
import styles from './LinkWithArrow.module.css';

type LinkWithArrowProps = {
  className?: string;
  children: React.ReactNode;
  as?: any;
} & (
  | { onClick?: never; href: string; target?: string; rel?: string }
  | { onClick?: () => void; href?: never; target?: never; rel?: never }
);

export const LinkWithArrow = ({
  as,
  className,
  href = '',
  onClick,
  children,
  target,
  rel,
}: LinkWithArrowProps) => {
  const style = {
    ['--link-arrow-icon' as any]: `url(${arrowImage.src})`,
  } as React.CSSProperties;
  const cls = [styles.root, className].filter(Boolean).join(' ');

  if (as) {
    const Tag: any = as;
    return (
      <Tag className={cls} style={style}>
        {children}
      </Tag>
    );
  }

  if (!href) {
    return (
      <span
        className={cls}
        style={style}
        onClick={onClick}
        role="button"
        tabIndex={0}
      >
        {children}
      </span>
    );
  }

  return (
    <a className={cls} style={style} href={href} target={target} rel={rel}>
      {children}
    </a>
  );
};
